// @flow
import React from 'react';
import { createRoot } from 'react-dom/client';
import ListFetch from './react/ListFetch';

document.querySelectorAll('.list-fetch__container').forEach(($list) => {
  const data = {
    url: $list.getAttribute('data-url') || '/api',
    categoryId: parseInt($list.getAttribute('data-category'), 10) || 0,
    langId: parseInt($list.getAttribute('data-lang'), 10) || 0,
    countMedia: parseInt($list.getAttribute('data-count_media'), 10) || 0,
    countPages: parseInt($list.getAttribute('data-count_pages'), 10) || 0,
    countPress: parseInt($list.getAttribute('data-count_press'), 10) || 0,
    countPublications: parseInt($list.getAttribute('data-count_pub'), 10) || 0,
    extension: $list.getAttribute('data-extension') || '',
  };

  const root = createRoot($list);

  root.render(<ListFetch {...data} />);
});
